"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiHost = void 0;
function getApiHost(app, env = 'dev') {
    let targetEnv = env.toLowerCase();
    targetEnv =
        targetEnv === 'prod'
            ? ''
            : targetEnv === 'devs'
                ? '-dev'
                : `-${targetEnv}`;
    return `https://api-${app}${targetEnv}.extensiv.com`;
}
exports.getApiHost = getApiHost;
